import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import StatsCard from "../cards/StatsCard";
import State from "../State";
import Modal from "./Modal";

const PassedLearningPathExamModal = ({
  id,
  isOpened,
  totalQuestions,
  correctCount,
  incorrectCount,
  percentage,
  learningPathId,
}) => {
  const { t } = useTranslation(["learningPaths"]);
  const [showModal, setShowModal] = useState(isOpened);

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const bootstrapModal = window.bootstrap?.Modal?.getOrCreateInstance(el);
    if (!bootstrapModal) return;
    if (isOpened) {
      bootstrapModal.show();
    } else {
      bootstrapModal.hide();
    }
  }, [isOpened, id]);

  useEffect(() => {
    setShowModal(isOpened);
  }, [isOpened]);

  const handleBackToDetails = () => {
    setShowModal(false);
    window.location.href = `/employee/learning_paths/${learningPathId}`;
  };

  const computedPercentage =
    totalQuestions > 0
      ? parseInt(((correctCount ?? 0) / totalQuestions) * 100)
      : 0;
  const displayPercentage =
    percentage != null && !Number.isNaN(Number(percentage))
      ? Number(percentage)
      : computedPercentage;

  return (
    <Modal id={id} maxWidth="600" isOpened={showModal} hasCloseBtn={false}>
      <State
        titleFontSize={24}
        descFontSize={14}
        className="passed-path-exam"
        color="#01c299"
        id="success-path-exam"
        hasIconStroke
        type="success"
        title={t("pathExamPassedTitle")}
        desc={t("pathExamPassedDesc")}
      >
        <div className="row state__details">
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="درجتك"
              num={`${displayPercentage}%`}
              state="default"
              titleFontColor="font-color-grey"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الصحيحة"
              num={correctCount ?? 0}
              state="success"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الخاطئة"
              num={incorrectCount ?? 0}
              state="fail"
            />
          </div>
        </div>
        <div className="d-grid gap-2 state__actions">
          <button
            type="button"
            className="btn btn-main-color"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleBackToDetails}
          >
            {t("pathExamBackToDetails")}
          </button>
        </div>
      </State>
    </Modal>
  );
};

export default PassedLearningPathExamModal;
